<template>
  <Button type="link" variant="black" icon="general.correctTranscription" data-testid="viewer-transcription-correct" @click.prevent="enterCorrectionMode"
    >Correct</Button
  >
</template>

<script setup lang="ts">
import { Button } from '@/storybook';
import { TrackEvents, useViewerTrack } from '@/modules/viewer/composables/useViewerTrack';

const { trackItemOwner } = useViewerTrack();

const enterCorrectionMode = () => {
  trackItemOwner(TrackEvents.VIEWER_TRANSCRIPTION_CORRECTION_ENTER);
};
</script>
